export const TypeTidCategory = Object.freeze({	
	"": "Sin Seleccionar",
	"company": "NIT",
	"person": "CUI",
	"foreign": "Extranjero",
});